import { render, staticRenderFns } from "./BottomMenu.vue?vue&type=template&id=a3365a5c&scoped=true&"
import script from "./BottomMenu.vue?vue&type=script&lang=js&"
export * from "./BottomMenu.vue?vue&type=script&lang=js&"
import style0 from "./BottomMenu.vue?vue&type=style&index=0&id=a3365a5c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3365a5c",
  null
  
)

export default component.exports